import dayjs from "dayjs";
import { ShieldAlert } from "lucide-react";
import { AED } from "../../lib/api";

export const FinesSection = ({ data, onDispute }) => (
  <div className="bg-white border border-[#e2ebe4] rounded-lg p-5" data-testid="fines-section">
    <h3 className="heading-upper text-sm tracking-widest text-[#144733] mb-4 flex items-center gap-2"><ShieldAlert className="w-4 h-4 text-[#009900]" /> Traffic fines</h3>
    {data.fines.length === 0 ? (
      <p className="text-sm text-[#57685e]">No traffic fines recorded for this booking. Authority charges may arrive later.</p>
    ) : (
      <div className="space-y-3">
        {data.fines.map((f) => (
          <div key={f.id} className="border border-[#e2ebe4] rounded-lg p-3" data-testid={`fine-card-${f.id}`}>
            <div className="flex justify-between items-start gap-2">
              <div>
                <div className="font-semibold text-sm text-[#0F1E17]">{f.type}</div>
                <div className="text-xs text-[#57685e]">
                  {f.id} · {dayjs(f.issued_at).format("DD MMM YYYY")} · {f.emirate}
                  {f.black_points > 0 && <span className="text-red-600 font-semibold"> · {f.black_points} black points</span>}
                </div>
                <div className="text-xs text-[#57685e] mt-1">Fine {AED(f.amount)} + admin fee (10% + VAT) {AED(f.admin_fee)}</div>
              </div>
              <div className="text-right shrink-0">
                <div className="font-bold text-[#0F1E17]">{AED(f.total)}</div>
                {f.status === "disputed" ? (
                  <span className="inline-block mt-1 text-[10px] uppercase tracking-wide bg-blue-50 text-blue-700 border border-blue-200 rounded-full px-2 py-0.5 font-semibold" data-testid="fine-disputed-badge">
                    Dispute {f.dispute.dispute_id}
                  </span>
                ) : (
                  <button onClick={() => onDispute(f)}
                    className="mt-1 border-2 border-[#009900] text-[#009900] rounded px-3 py-1.5 text-[11px] font-medium uppercase tracking-wide hover:bg-[#f0f9f0]"
                    data-testid="dispute-fine-btn">Dispute</button>
                )}
              </div>
            </div>
            {f.status === "disputed" && (
              <p className="text-[11px] text-blue-700 mt-2">Dispute submitted — if successful, refunds take 15–45 days depending on the emirate.</p>
            )}
          </div>
        ))}
        <div className="flex justify-between font-bold text-sm border-t border-[#e2ebe4] pt-2">
          <span>Total fines</span><span>{AED(data.fines_total)}</span>
        </div>
      </div>
    )}
  </div>
);
